import { render, staticRenderFns } from "./Editpublish.vue?vue&type=template&id=56bdc031&scoped=true&"
import script from "./Editpublish.vue?vue&type=script&lang=js&"
export * from "./Editpublish.vue?vue&type=script&lang=js&"
import style0 from "./Editpublish.vue?vue&type=style&index=0&id=56bdc031&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bdc031",
  null
  
)

component.options.__file = "Editpublish.vue"
export default component.exports